import script from "./AddBrandToShopDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBrandToShopDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddBrandToShopDialog.vue?vue&type=style&index=0&id=3cccee02&lang=css"
import "./AddBrandToShopDialog.vue?vue&type=style&index=1&id=3cccee02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cccee02"]])

export default __exports__